<template>
  <div id="app">
    <side-menu></side-menu>
    <!--div v-bind:class="{row: true, expanded: true,
                        'side-menu': this.$store.state.sideMenu.show,
                        'route-container': true}"-->
    <transition name="slide">
      <search v-show="displaySearch"></search>
    </transition>

    <div class="row expanded route-container">
      <div class="small-12 columns">
        <router-view/>
      </div>
    </div>

    <session-loader></session-loader>
    <phone-app></phone-app>
    <reservation-notes-modal></reservation-notes-modal>
    <flight-information-modal></flight-information-modal>
    <country-code-modal></country-code-modal>
    <loader></loader>
    <alert></alert>
    <reason-modal></reason-modal>
  </div>
</template>

<script>
/* global CONFIG */
import CountryCodeModal from './CountryCodeModal'
import FlightInformationModal from './FlightInformationModal'
import PhoneApp from './PhoneApp'
import ReservationNotesModal from './ReservationNotesModal'
import SideMenu from './SideMenu'
import SessionLoader from './SessionLoader'
import Search from './Search'
import Loader from './Loader'
import Alert from './Alert'
import ReasonModal from './ReasonModal'
export default {
  name: 'app',
  components: {
    CountryCodeModal, FlightInformationModal, PhoneApp, 
    ReservationNotesModal, SideMenu, SessionLoader, Search,
    Loader, Alert, ReasonModal
  },
  computed: {
    displaySearch () {
      if (['Login', 'ProviderPrintPlacard', 'PasswordReset', 'PasswordResetDriver'].indexOf(this.$route.name) > -1) return false
      else return this.$store.state.searchGlobal.enable
    },
    store () { return this.$store.state }
  },
  mounted () {
    let self = this
    self.$plugins.fcm.init(CONFIG.Firebase)
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/global.scss';

.route-container{
  margin-left: 0;
  transition: all 250ms;
  &.side-menu{
    margin-left: 250px
  }
}

.slide-enter-active, .slide-leave-active { transition: all .2s ease; }
.slide-enter, .slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/App/index.vue